/* esm.sh - d3-transition@3.0.1/src/transition/remove */
function r(t){return function(){var n=this.parentNode;for(var i in this.__transition)if(+i!==t)return;n&&n.removeChild(this)}}function e(){return this.on("end.remove",r(this._id))}export{e as default};
//# sourceMappingURL=remove.mjs.map